import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import { isDefined, isString } from '@dateam/ark';
var LocalStore = /*#__PURE__*/function () {
  function LocalStore() {
    var _window;
    _classCallCheck(this, LocalStore);
    this._storage = void 0;
    this.isSupported = true;
    this._storage = ((_window = window) === null || _window === void 0 ? void 0 : _window.localStorage) || localStorage;
    if (!isDefined(this._storage)) {
      this.isSupported = false;
      throw new Error('The LocalStorage API might not be supported by this platform.');
    }
  }
  return _createClass(LocalStore, [{
    key: "get",
    value: function get(key) {
      if (!this.isSupported || !this._storage.length) return null;
      try {
        var stringData = this._storage.getItem(key);
        return isString(stringData) ? JSON.parse(stringData) : null;
      } catch (err) {
        // Logger.error(
        //     { domain: LogDomain.Store, context: this, method: this.get },
        //     `Storage: An error occurred. (${err.message})`
        // );
      }
      return null;
    }
  }, {
    key: "set",
    value: function set(key, data) {
      if (!this.isSupported) return;
      try {
        var stringData = JSON.stringify(data);
        this._storage.setItem(key, stringData);
      } catch (err) {
        // Logger.error(
        //     { domain: LogDomain.Store, context: this, method: this.get },
        //     `Storage: An error occurred. (${err.message})`
        // );
      }
    }
  }, {
    key: "clear",
    value: function clear(key) {
      if (!this.isSupported) return;
      this._storage.removeItem(key);
    }
  }, {
    key: "clearAll",
    value: function clearAll() {
      if (!this.isSupported) return;
      this._storage.clear();
    }
  }]);
}();
export default LocalStore;